import { Input, Select, Checkbox } from "antd"
import React, { useMemo, useRef } from "react"
import CustomRangePicker from "src/components/CustomRangePickerMobile/CustomRangePicker"
import Button from "src/components/MyButton/Button"
import SvgIcon from "src/components/SvgIcon"
import { InputSearchStyle } from "../../../Setting/common/styled"
import SelectProvider from "src/components/Dropdown/SelectProvider"
import SelectPackage from "src/components/Dropdown/SelectPackage"
import SelectCustomer from "src/components/Dropdown/SelectCustomer"
import SelectCarrier from "src/components/Dropdown/SelectCarrier"
import SelectLotNumber from "src/components/Dropdown/SelectApprovalBatchNumber"
import SelectSimType from "src/components/Dropdown/SelectSimType"
import { debounce } from "lodash"
import SelectLocalRoaming from "src/components/Dropdown/SelectLocalRoaming"
import SelectTypeSim from "src/components/Dropdown/SelectTypeSim"

const FilterIn = ({ filter, setFilter, setKeyword }) => {
  const inputSearchRef = useRef()

  const onSearch = () => {
    const keyword = inputSearchRef.current?.trim() || ""
    setKeyword(keyword)
  }

  const onClearSearch = () => {
    inputSearchRef.current = ""
    setKeyword("")
  }

  const debouncedSetFilter = useMemo(
    () =>
      debounce(value => {
        setFilter(prev => ({ ...prev, approval_batch_number: value }))
      }, 1000),
    [setFilter],
  )

  const handleChange = e => {
    debouncedSetFilter(e.target.value)
  }

  return (
    <div
      style={{
        display: "flex",
        flexWrap: "wrap",
        gap: 16,
        marginBottom: 16,
        alignItems: "flex-start",
        width: "100%",
      }}
    >
      {/* Left filter group */}
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          gap: 12,
          flex: 1,
          minWidth: 250,
        }}
      >
        <SelectLotNumber
          style={{ width: 150 }}
          onChange={val => setFilter(prev => ({ ...prev, warehouse_approval_id: val }))}
        />
        <Select
          placeholder={<span style={{ color: "#bfbfbf" }}>Trạng thái</span>}
          allowClear
          style={{ width: 150 }}
          onChange={val => setFilter(prev => ({ ...prev, status: val }))}
        >
          <Select.Option value="0">Chưa kích hoạt</Select.Option>
          <Select.Option value="1">Đã kích hoạt</Select.Option>
          <Select.Option value="2">Đã vô hiệu</Select.Option>
          <Select.Option value="3">Đã gia hạn</Select.Option>
          <Select.Option value="4">Đã cấp lại</Select.Option>
          <Select.Option value="5">Đã thu hồi</Select.Option>
        </Select>
        <Select
          placeholder={<span style={{ color: "#bfbfbf" }}>Loại thanh toán</span>}
          allowClear
          style={{ width: 150 }}
          onChange={val => setFilter(prev => ({ ...prev, payment_type: val }))}
        >
          <Select.Option value="1">Trả trước</Select.Option>
          <Select.Option value="2">Trả sau</Select.Option>
        </Select>
        <Select
          placeholder={<span style={{ color: "#bfbfbf" }}>Loại tiền tệ</span>}
          allowClear
          style={{ width: 150 }}
          onChange={val => setFilter(prev => ({ ...prev, currency_type: val }))}
        >
          <Select.Option value="vnd">VND</Select.Option>
          <Select.Option value="usd">USD</Select.Option>
        </Select>

        <SelectSimType
          style={{ width: 150 }}
          onChange={val => setFilter(prev => ({ ...prev, sim_type: val }))}
        />
        <SelectLocalRoaming
          style={{ width: 150 }}
          onChange={val => setFilter(prev => ({ ...prev, scope: val }))}
        />
        <SelectProvider
          style={{ width: 150 }}
          onChange={val => setFilter(prev => ({ ...prev, supplier_id: val }))}
        />
        <SelectCarrier
          style={{ width: 150 }}
          onChange={val => setFilter(prev => ({ ...prev, carrier_id: val }))}
        />
        <SelectPackage
          style={{ width: 150 }}
          onChange={val => setFilter(prev => ({ ...prev, package_id: val }))}
          listAll={true}
        />

        {/* Checkbox styled as input item */}
        <div
          style={{
            width: 210,
            height: 40,
            border: "1px solid #d9d9d9",
            borderRadius: 6,
            display: "flex",
            alignItems: "center",
            paddingLeft: 12,
            backgroundColor: "#fff",
          }}
          onClick={e => e.stopPropagation()}
        >
          <Checkbox
            onChange={e =>
              setFilter(prev => ({
                ...prev,
                over_50_percent_time: e.target.checked || undefined,
              }))
            }
            style={{ color: "rgba(0, 0, 0, 0.45)" }}
          >
            Trên 50% thời gian
          </Checkbox>
        </div>
      </div>

      {/* Search box */}
      <div style={{ flexShrink: 0, minWidth: 250 }}>
        <InputSearchStyle>
          <Input
            allowClear
            className="custom-input"
            maxLength={50}
            placeholder="Seri SIM, số thuê bao"
            onChange={e => (inputSearchRef.current = e.currentTarget.value)}
            onPressEnter={onSearch}
            onClear={onClearSearch}
          />
          <div className="custom-icon-search">
            <SvgIcon name="searchStatistic" onClick={onSearch} />
          </div>
        </InputSearchStyle>
      </div>
    </div>
  )
}

export default FilterIn
